import React, { Fragment, useEffect } from "react";
import * as TestEnviromentUtils from "../utils/testEnviroment.utils";

interface TestBackgroundProps {
    active: boolean
}

export const TestBackground: React.FC<TestBackgroundProps> = ({ children, active }) => {

    useEffect(() => {
        if (active) {
            TestEnviromentUtils.addTestingBackground()
        } else {
            TestEnviromentUtils.removeTestingBackground()
        }
    }, [active]);

    return (
        <Fragment>
            {children}
        </Fragment>
    );
};


export default TestBackground;
